<template>
	<v-row>
		<v-flex xs10>
			<edit-concept-component
				:items="items"
				:filters="filters"
				:filtersSelected="filtersSelected"
				:updateFilters="updateFilters"
				:weight="weight"
				:weightSelected="weightSelected"
				:updateWeight="updateWeight"
				:rows="rows"
				:importance="importance"
				:rowsValue="rowsValue"
				:saveRowChanges="saveRowChanges"
				:paramsValue="paramsValue"
				:addRow="addRow"
				:baseSize="baseSize"
				:sumWeight="sumWeight"
				:updateData="updateData"
				:hasNoneRow="hasNoneRow"
				:noneRow="noneRow"
				:saveToExcel="saveToExcel"
				:toggleNoneRow="toggleNoneRow"
				:deleteRow="deleteRow"
				:copyRow="copyRow"
			></edit-concept-component>
		</v-flex>
		<v-flex xs2>
			<list-concept-component
				:saveConcept="saveConcept"
				:concepts="concepts"
				:changePage="changePage"
				:saveDialog="saveDialog"
				:isNotSaved="isNotSaved"
				:deleteConcept="deleteConcept"
			></list-concept-component>
		</v-flex>
		<save-dialog
			:saveDialog="saveDialog"
			:saveConcept="saveConcept"
			:changeIsNotSaved="changeIsNotSaved"
			:changePage="changePage"
		></save-dialog>
	</v-row>
</template>

<script>
  import {EditConceptComponent, ListConceptComponent, SaveDialog} from './ProjectPageComponents/'
  import asyncQuery from "../../asyncQuery";

  export default {
    name: "ProjectPage",
    props: {
      toggleLoading: Function,
      changePage: Function,
      isNotSaved: Boolean,
      changeIsNotSaved: Function,
      showMessage: Function,
      changeConfirmFunction: Function,
      changeProjectName: Function,
    },
    components: {
      EditConceptComponent,
      ListConceptComponent,
      SaveDialog,
    },
    data() {
      return {
        weight: [],
        weightSelected: 'without_weight',
        rows: [],
        rowsValue: [],
        paramsValue: {},
        items: [],
        filters: [],
        filtersSelected: [],
        editDialogIsOpen: false,
        editDialogValues: {},
        editRowIndex: null,
        baseSize: null,
        sumWeight: null,
        importance: {},
        noneRow: false,
        hasNoneRow: false,
        concepts: [],
        saveDialog: {
          dialog: false,
          editableConcept: this.$route.params.concept || '',
          nextRoute: null,
        },
      }
    },
    watch: {
      '$route'() {
        this.$data.weight = [];
        this.$data.weightSelected = 'without_weight';
        this.$data.hasNoneRow = false;
        this.$data.noneRow = false;
        this.$data.importance = {};
        this.$data.baseSize = null;
        this.$data.sumWeight = null;
        this.$data.rows = [];
        this.$data.paramsValue = {};
        this.$data.rowsValue = [];
        this.$data.filtersSelected = [];
        this.$data.concepts = [];
        this.$data.saveDialog = {
          dialog: false,
          editableConcept: this.$route.params.concept || '',
          nextRoute: null,
        };
        this.getData();
        if (this.saveDialog.editableConcept) this.getConcept();
      },
    },
    mounted: function () {
      this.getData();
      if (this.saveDialog.editableConcept) this.getConcept();
      // меняем функцию подвтерждения при смене ссылки на открытие диалога с сохранением концепции
      this.changeConfirmFunction(
        (function (nextRoute) {
          this.$data.saveDialog.dialog = true;
          this.$data.saveDialog.nextRoute = nextRoute;
        }).bind(this)
      )
    },
    methods: {
      getData: function () {
        asyncQuery.bind(this)({
          url: `/api/project/${this.$route.params.name}`,
          handleSuccess: json => {
            this.changeProjectName(json.project);
            this.$data.items = json.categories;
            this.$data.filters = json.filters;
            this.$data.weight = json.weight;
            this.$data.concepts = json.concepts;

            const values = {};
            json.categories.map(el => values[el.value] = '');
            this.$data.paramsValue = values;
          },
          handleStatus: {
            404: () => {
              this.showMessage(`Проект "${this.$route.params.name}" отсутствует или у вас нет к нему доступа.`, 'error');
              this.changePage({'name': 'MainPage'})
            },
          },
        })
      },
      updateData: function (firstLoading) {
        if (!this.rowsValue.length) return;
        asyncQuery.bind(this)({
          url: `/api/data/${this.$route.params.name}`,
          method: 'POST',
          body: JSON.stringify({
            categories: this.noneRow ? [...this.rowsValue, 'none_row'] : this.rowsValue,
            filters: this.filtersSelected,
            weight: this.weightSelected,
          }),
          handleSuccess: json => {
            this.$data.rows = json.category;
            this.$data.baseSize = json.baseSize;
            this.$data.sumWeight = json.sumWeight;
            this.$data.importance = json.importance;
            this.$data.hasNoneRow = json.hasNoneRow;
            // если, это не первая загрука, указываем, что концепция изменилась
            if (!firstLoading) this.changeIsNotSaved(true)
          },
        })
      },
      getConcept: function () {
        asyncQuery.bind(this)({
          url: `/api/concept/${this.$route.params.name}/${this.saveDialog.editableConcept}`,
          handleSuccess: json => {
            this.$data.filtersSelected = json.filters;
            this.$data.weightSelected = json.weight;
            this.$data.rowsValue = json.categories;
            if (json.noneRow) this.$data.noneRow = json.noneRow;
            // обновляем данные по концепции с указанием, что эта первая загрузка
            this.updateData(true);
          },
          handleStatus: {
            404: () => {
              this.showMessage(`Концепции "${this.saveDialog.editableConcept}" по проекту "${this.$route.params.name}" не существует.`, 'error');
              this.changePage({name: 'ProjectPage', params: {name: this.$route.params.name}})
            },
          },
        })
      },
      addRow: function (val) {
        this.$data.rowsValue.push(val);

        const values = {};
        this.items
          .filter(el => !el.items.length)
          .map(el => values[el.value] = '');
        this.$data.paramsValue = values;
        this.updateData();
      },
      toggleNoneRow: function () {
        this.$data.noneRow = !this.noneRow;
        this.updateData();
      },
      deleteRow: function (idx) {
        confirm(`Вы уверены, что хотите удалить строку?`) && this.rowsValue.splice(idx, 1);
        this.updateData();
      },
      copyRow: function (idx) {
        this.rowsValue = [...this.rowsValue.slice(0, idx + 1), this.rowsValue[idx], ...this.rowsValue.slice(idx + 1, this.rowsValue.length)];
        this.updateData();
      },
      updateFilters: function (val) {
        this.$data.filtersSelected = val;
        this.updateData();
      },
      updateWeight: function (val) {
        this.$data.weightSelected = val;
        this.updateData();
      },
      saveRowChanges: function (data, id) {
        this.$data.rowsValue = [
          ...this.rowsValue.slice(0, id),
          data,
          ...this.rowsValue.slice(id + 1)
        ];
        this.updateData();
      },
      saveToExcel: function () {
        asyncQuery.bind(this)({
          url: `/api/save_excel/${this.$route.params.name}`,
          method: 'POST',
          body: JSON.stringify({
            categories: this.noneRow ? [...this.rowsValue, 'none_row'] : this.rowsValue,
            filters: this.filtersSelected,
            weight: this.weightSelected,
            concept: this.saveDialog.editableConcept,
          }),
          handleSuccess: json => {
            const byteCharacters = atob(json['file']);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob(
              [byteArray],
              {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
            );
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = json['fileName'];
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();
          },
        })
      },
      saveConcept: function () {
        asyncQuery.bind(this)({
          url: `/api/concept/${this.$route.params.name}`,
          method: 'POST',
          body: JSON.stringify({
            categories: this.noneRow ? [...this.rowsValue, 'none_row'] : this.rowsValue,
            filters: this.filtersSelected,
            weight: this.weightSelected,
            project: this.$route.params.name,
            concept: this.saveDialog.editableConcept,
          }),
          handleSuccess: json => {
            if (json.status === 'ok') {
              this.changeIsNotSaved(false);
              this.changePage({
                name: 'ProjectPageConcept',
                params: {name: this.$route.params.name, concept: this.saveDialog.editableConcept}
              });
              this.$data.saveDialog.dialog = false;
              if (this.saveDialog.nextRoute) this.changePage(this.saveDialog.nextRoute);
            }
          },
          handleStatus: {
            200: () => {
              this.showMessage(`Концепция "${this.saveDialog.editableConcept}" по проекту "${this.$route.params.name}" сохранена.`, 'success');
            },
            400: () => {
              this.showMessage(`Что-то пошло не так... концепция "${this.saveDialog.editableConcept}" по проекту "${this.$route.params.name}" не сохранена.`, 'error');
            }
          }
        })
      },
      deleteConcept: function (concept) {
        if (!confirm(`Удалить концепцию "${concept}"?`)) return;
        const project = this.$route.params.name;
        asyncQuery.bind(this)({
          url: `/api/concept/${project}/${concept}`,
          method: 'DELETE',
          handleSuccess: json => {
            if (json.status === 'ok') {
              this.showMessage(`Концепция "${concept}" удалена!`, 'success');
              concept === this.$route.params.concept
                ? this.changePage({
                  name: 'ProjectPage',
                  params: {name: this.$route.params.name}
                })
                : this.getData();
            }
          },
        })
      },
    },
  }
</script>

<style scoped>

</style>

<style>
	.flex {
		padding: 0 0 10px 10px;
	}
</style>